import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Changelog from '../components/Changelog';

function Home({ currentUser }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="max-w-2xl mx-auto p-4">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          {t('Welcome on the Gallery application')}
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-300">
          {t('This application allows you to view and export photos taken every day on the field by the teams.')}
        </p>
        <div className="mt-8">
          <button
            onClick={() => navigate('/gallery')}
            className="bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            {t('Start')}
          </button>
        </div>

        {(currentUser?.isadmin || currentUser?.issuperadmin) && (
          <Changelog />
        )}
      </div>
    </div>
  );
}

export default Home;